<template>
  <div class="c-corrected-age">
    <div class="text">
      <div class="text__left"></div>
      <div class="text__right">現在日期：9月1日</div>
    </div>
    <div class="text">
      <div class="text__left">-</div>
      <div class="text__right">預產期：5月1日</div>
    </div>
    <div class="divide"></div>
    <div class="text">
      <div class="text__left">=</div>
      <div class="text__right">4個月</div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CorrectedAge',
});
</script>
<style lang="scss" scoped>

.c-corrected-age {
  width: 150px;
  margin-top: 20px;
}
.text {
  @include flex(space-between);

  &__left {
    @include font-normal()
  }

  &__right{
    @include font-normal()

  }
}

.divide {
  border-bottom: 1px solid $c-main;
  margin: 4px 0;
}
</style>
